export const clearByRegEx = (cache: any, regExText: string) => {
  // https://medium.com/@martinseanhunt/how-to-invalidate-cached-data-in-apollo-and-handle-updating-paginated-queries-379e4b9e4698
  // https://medium.com/rbi-tech/tips-and-tricks-for-working-with-apollo-cache-3b5a757f10a0
  // https://danreynolds.ca/tech/2020/05/04/Apollo-3-Client-Cache/
  const rootQuery = cache.data.data.ROOT_QUERY;
  const regEx = new RegExp(regExText);
  Object.keys(rootQuery).forEach(key => {
      if (key.match(regEx)) { // matches all news cache keys that rely on newsStatus arg
          cache.evict({ id: 'ROOT_QUERY', fieldName: key }); // delete cache entry
      }
  });
}
